import { useEffect } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useMergedBrandShellAppearance } from '@/shared/api/brandQueries'
import { routeTitleKey } from '@/shared/lib/routeTitles'
import { usePageTitleValue } from '@/shared/hooks/usePageTitle'

export function RouteDocumentTitle() {
  const { t } = useTranslation()
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const brand = useMergedBrandShellAppearance()
  const brandName = brand?.name?.trim() ? brand.name.trim() : t('home.brandFallback')
  const pageTitle = usePageTitleValue()
  const key = routeTitleKey(pathname)
  const routePageTitle = key === null ? null : t(`ui.page_title.labels.${key}`)
  const title = pageTitle === null && routePageTitle === null ? null : t('ui.page_title.pattern', {
    page: pageTitle ?? routePageTitle,
    brandName,
  })

  useEffect(() => {
    if (title !== null) {
      document.title = title
    }
  }, [title])

  return null
}
